class Style {
    static blockTitleStyle(obj) {
        return `font-size: ${ obj.titleSize };` +
        `color: ${ obj.titleColor };` +
        `font-weight: ${ obj.isBold ? 'bold' : 'normal' };` +
        `font-style: ${ obj.isItalic ? 'italic' : 'normal' };` +
        `text-decoration: ${ obj.isUnderline ? 'underline' : 'none' };`
    }

    static blockTextStyle(obj) {
        return `font-size: ${ obj.textSize };` +
        `color: ${ obj.textColor };` +
        `font-weight: ${ obj.isBold ? 'bold' : 'normal' };` +
        `font-style: ${ obj.isItalic ? 'italic' : 'normal' };` +
        `text-decoration: ${ obj.isUnderline ? 'underline' : 'none' };`
    }

    static blockBtnStyle(obj) {
        return `font-size: ${ obj.buttonTextSize };` +
        `color: ${ obj.buttonTextColor };` +
        `font-weight: ${ obj.isBold ? 'bold' : 'normal' };` +
        `font-style: ${ obj.isItalic ? 'italic' : 'normal' };` +
        `text-decoration: ${ obj.isUnderline ? 'underline' : 'none' };`
    }
}

export { Style }


// WEBPACK FOOTER //
// ./src/config/style.js